<template>
  <div class="courses">
    <div class="label-choose-box">
        <div class="choosed-symbol">
            <div class="year-choose">
                <div class="year-title" style="margin-top:10px;">培训年度:</div>
                <ul class="year" style="margin-top:10px;border:none">
                    <li :class="{on:yeartabState==''}" @click="courseYear()">全部</li>
                    <li style="margin-left:20px;" :class="{on:yeartabState==item}" v-for="(item,index) in kecheng_year" :key="index" @click="courseYear(item,index)">{{item}}</li>
                </ul>
            </div>
            <div class="year-choose">
                <div  class="year-title">精品课程:</div>
                <ul class="year">
                    <li :class="{on:typestart==''}" @click="courseType_id()" >全部</li>
                    <li :class="{on:typestart==index+1}" v-for="(item,index) in type_name" :key="index" @click="courseType_id(item.id,index)">{{item.name}}</li>
                </ul>
            </div>
            <div class="course-choose">
                <div class="course-title">课程类型:</div>
                <ul class="course">
                    <li :class="{on:typetabState==''}" @click="courseType()" >全部</li>
                    <li :class="{on:typetabState==index+1}" v-for="(item,index) in itmer" :key="index" @click="courseType(item.id,index)">{{item.name}}</li>
                </ul>
            </div>
            <!-- <div class="kinds-choose">
                <div class="kinds-title">课程分类:</div>
                <ul class="kinds">
                    <li :class="{on:categorytabState==''}" @click="courseCategory()">全部</li>
                    <li :class="{on:categorytabState==item.id}" v-for="(item,index) in kecheng_category" :key="index" @click="courseCategory(item.id)">{{item.name}}</li>            
                </ul>
            </div> -->
        </div>
    </div>
    <div class="course-box">
        <router-link :to="'/courseDetails/' + item.id" v-for="(item,index) in courseslist" :key="index" class="course-item" >
            <div class="item-img"><img :src="item.img_url"></div>
            <p class="item-name">{{item.title}}</p>
            <div class="item-other">
                <!-- <div class="item-time">{{item.xueshi_num}}学时</div> -->
                <div class="item-teacher">主讲：<span class="teacher-name">{{item.jiangshi.name}}</span></div>
            </div>  
        </router-link>     
    </div>
  </div>
</template>

<script>
import qs from 'qs'
export default {
  name: 'courses',
  data () {
    return {
      //课程列表
      courseslist:'',
      //课程年份
      kecheng_year:['全部'],
      //选修和必修
      type_name:[{name:'必修课',id:'1'},{name:'选修课',id:'2'}],
      //课程类型
      kecheng_type:'',
      //课程分类
      kecheng_category:'',
      //课程年份参数
      yearid:'',
      //课程类型参数
      typeid:'',
      //课程分类参数
      categoryid:'',
      //yeartabState
      yeartabState:'',
      typestart:'',
      //yeartabState
      typetabState:'',
      //yeartabState
      categorytabState:'',
      
      itmer:['全部'],
      itemr:[],
      type_id:""
    }
  },
  created(){
    this.typetabState=this.$route.query.typeid;
  },
  mounted(){
    let that = this;
    //获取课程年份 
    this.$axios({
      method: 'get',
      url: '/kecheng/get_kecheng_year',
      }).then(function (response) {
        if(response.data.status=="ok"){
          //console.log("课程年份")
          //console.log(response.data.data)
          that.kecheng_year=response.data.data;
        }else if((response.data.status=="error")){
          that.$message.error({message:response.data.errormsg,duration:1600});
        }else if((response.data.status=="relogin")){
          that.removeInfo();
        }
      });
     //获取课程类型 
    // this.$axios({
    //   method: 'get',
    //   url: '/kecheng/get_kecheng_type',
    //   }).then(function (response) {
    //     if(response.data.status=="ok"){
    //       //console.log("课程类型")
    //       //console.log(response.data.data)
    //       that.kecheng_type=response.data.data;
    //     }else if((response.data.status=="error")){
    //       that.$message.error({message:response.data.errormsg,duration:1600});
    //     }else if((response.data.status=="relogin")){
    //       that.removeInfo();
    //     }
        
    //   });
      //获取课程分类 
    this.$axios({
      method: 'get',
      url: '/kecheng/get_kecheng_category',
      }).then(function (response) {
        if(response.data.status=="ok"){
          //console.log("课程分类")
          //console.log(response.data.data)
          that.kecheng_category=response.data.data;
          that.itmer = that.itmer.concat(that.kecheng_category);
          //console.log(that.itmer);
          that.courseType(that.typetabState);
        }else if((response.data.status=="error")){
          that.$message.error({message:response.data.errormsg,duration:1600});
        }else if((response.data.status=="relogin")){
          that.removeInfo();
        }
        
      });
       //获取课程列表 
    let datacourse={year:'2019', type_id:'',category_id:''}
    this.$axios({
      method: 'post',
      url: '/kecheng/get_kecheng_list',
      data: qs.stringify(datacourse) 
      }).then(function (response) {
        if(response.data.status=="ok"){
          //console.log("课程列表")
          //console.log(response.data.data.data)
          that.courseslist=response.data.data.data;
        }else if((response.data.status=="error")){
          that.$message.error({message:response.data.errormsg,duration:1600});
        }else if((response.data.status=="relogin")){
          that.removeInfo();
        }
        
      });
  },
  methods:{
      removeInfo(){
        let that = this;
        that.$message.error({message:"重新登录",duration:1600});
        localStorage.removeItem("uid");
        localStorage.removeItem("token");
        localStorage.removeItem("sex");
        localStorage.removeItem("name");
        localStorage.removeItem("mobile");
        localStorage.removeItem("id_card");
        setTimeout(() => {
          that.$router.push({ path: '/' });
        }, 1600);
      },
      courseYear(id,index) {
        console.log(id)
        if(id){
          this.yeartabState=id;
          this.yearid='2020';
          this.getCourseList(this.yearid,this.categoryid,this.type_id);
        }else{
          this.yeartabState='';
          this.getCourseList(this.yearid,this.categoryid,this.type_id);
        }
      }, 
      courseType_id(id,idx){
        console.log(id)
        if(id){
          this.typestart = id
        }else{
          this.typestart = ''
        }
        
        this.getCourseList(this.yearid,this.categoryid,id);
      },
      courseType(id,index){
        this.categoryid = id;
        if(id){
          this.typetabState=index+1;
          this.typeid=id;
          this.getCourseList(this.yearid,this.categoryid,this.type_id);
        }else{
          this.typetabState='';
          this.yearid='';
          this.categoryid=id;
          this.getCourseList(this.yearid,this.categoryid,this.type_id);
        }
      },  
      // courseCategory(id){
      //   if(id){
      //     this.categorytabState=id;
      //     this.categoryid=id;
      //     this.getCourseList(this.yearid,this.categoryid);
      //   }else{
      //     this.categorytabState='';
      //     this.yearid='';
      //     this.categoryid='';
      //     this.getCourseList(this.yearid,this.categoryid);
      //   }
      // },
      //点击标签选项后获取课程列表 
      getCourseList(yearid,categoryid,type_id){
        // console.log(yearid,categoryid,type_id)
        let that = this;
        let datacourse={year:yearid,category_id:categoryid,page:'1',num:'10',type:type_id}
        this.$axios({
          method: 'post',
          url: '/kecheng/get_kecheng_list',
          data: qs.stringify(datacourse) 
          }).then(function (response) {
            if(response.data.status=="ok"){
              // console.log("课程列表")
              // console.log(response.data.data.data)
              that.courseslist=response.data.data.data;
            }else{
              
            }
          });
      },



  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    .courses{width: 100%;margin-top:10px;
        .label-choose-box{width: 100%;overflow: hidden;font-size: 16px;color:#808080;
            .choosed-symbol{width:1200px; margin:0 auto}
            .chooseed{width: 100%;height: 15px;
                .chooseed-content{display: flex;align-items: center;height: 100%;width: 1200px;margin: 0 auto;
                    .chooseed-title{font-size: 16px;padding-bottom: 5px;margin:0 auto;font-weight: bold;}
                    
                }
            }
        }
        .course-box{display: flex;flex-wrap:wrap;justify-content: flex-start;width: 1200px;margin: 0 auto;
            .course-item{width: 225px;height: 225px;margin-top: 15px;margin-right: 15px;
                .item-img{width: 225px;height: 126px;
                
                    img{width: 100%;height: 100%;border-radius: 10px ;}
                }
                &:hover{box-shadow: 0 0 10px #ccc;cursor: pointer;border-radius: 10px ;}
                .item-name{font-size: 14px; color:#313131;letter-spacing: 2px;padding:0 8px;line-height: 20px;margin-top: 8px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;}
                .item-other{display: flex;justify-content:space-between;margin-top: 15px;padding:0 8px;
                    .item-teacher{color:#313131;font-size: 14px;}
                    .item-time{color:#fb0808;font-size: 14px;}
                }
            }
        }
    }

    .label-choose-box .year-choose,.label-choose-box .course-choose,.label-choose-box .kinds-choose{display: flex;-align-items: center;-height: 80px;}
    .label-choose-box .year-choose .year,.label-choose-box .course-choose .course,.label-choose-box .kinds-choose .kinds{display: flex;list-style: none;flex-wrap:wrap;}
    .label-choose-box .year-choose .more,.label-choose-box .course-choose .more,.label-choose-box .kinds-choose .more{font-size: 16px;position: absolute;right: 0;color:#808080;}
    .label-choose-box .year-choose .year-title,.label-choose-box .course-choose .course-title,.label-choose-box .kinds-choose .kinds-title{font-size: 16px;padding-bottom: 5px;width: 83px;height: 26px;}
    .label-choose-box .year-choose .year li,.label-choose-box .course-choose .course li,.label-choose-box .kinds-choose .kinds li{font-size: 16px;margin: 0 6px 10px;padding-bottom: 5px;cursor: pointer;}
    .label-choose-box  .on{border-bottom: 2px solid #eb2d2d;}
    .label-choose-box  li:hover{border-bottom: 2px solid #eb2d2d;}
    .label-choose-box .year-choose[data-v-0842bae4], .label-choose-box .course-choose[data-v-0842bae4], .label-choose-box .kinds-choose[data-v-0842bae4]{
      border: none;
      padding: 0;
      // margin-top:5px;
    }

    .course{
      // border:1px #f00 solid;
      width:1100px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/courses.vue